import getRole from "./RoleService";

const uri = `${import.meta.env.VITE_BASE_URL}/api/ranking-v2`;


const GetRankingByMonth = async (
  startDate,
  endDate,
  size,
  page
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const queryParams = new URLSearchParams({
        startDate,
        endDate,
        size,
        page,
      }).toString();

      const response = await fetch(`${uri}/?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};
const GetRankingByDate = async (
  dateFrom,
  dateTo,
  numTopUserPerDay,
  rangeDateEventId,
  rangeDateEventName,
  phoneNumber
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;
      const queryParams = new URLSearchParams({
        dateFrom,
        dateTo,
        numTopUserPerDay,
        rangeDateEventId,
        rangeDateEventName,
        phoneNumber,
      }).toString();

      const response = await fetch(`${uri}/bxh-by-day?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const GetRankingByWeek = async (
  numTopUserPerDay,
  rangeDateEventId,
  rangeDateEventName,
  phoneNumber
) => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const queryParams = new URLSearchParams({
        numTopUserPerDay,
        rangeDateEventId,
        rangeDateEventName,
        phoneNumber,
      }).toString();

      const response = await fetch(`${uri}/bxh-by-week?${queryParams}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

const GetMyRanking = async () => {
  try {
    const role = await getRole();
    if (role) {
      const { token } = role;

      const response = await fetch(`${uri}/my-rank`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        return data;
      } else if (response.status === 401) {
        return {
          status_code: 401,
          message: "Token hết hạn, vui lòng đăng nhập lại.",
        };
      } else {
        return {
          status_code: 500,
          message: "Lỗi không xác định!",
        };
      }
    } else {
      return {
        status_code: 401,
        message: "Token hết hạn, vui lòng đăng nhập lại.",
      };
    }
  } catch (err) {
    console.log(err);
    return { success: false, message: "Lỗi server" };
  }
};

export { GetRankingByDate, GetRankingByWeek, GetMyRanking, GetRankingByMonth };
